import { render, staticRenderFns } from "./rightsRules.vue?vue&type=template&id=62fb3394&scoped=true&"
import script from "./rightsRules.vue?vue&type=script&lang=js&"
export * from "./rightsRules.vue?vue&type=script&lang=js&"
import style0 from "./rightsRules.vue?vue&type=style&index=0&id=62fb3394&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb3394",
  null
  
)

export default component.exports